/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import {
  CreatePresentationProps,
  DeletePresentationProps,
  UpdatePresentationProps,
} from "./components";

const is = require("is_js");

const SERVICE_NAME = "PresentationListPageService";
const log: any = LoggerModule.getInstance();

export class PresentationListPageService {
  private static instance: PresentationListPageService;
  private vapp: VApplication;
  private loginRestAPI: string;
  private criteria: any;
  private headers: any;
  private token: string;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
    this.token = props?.token;
  }

  public static getInstance(props: any = {}): PresentationListPageService {
    if (!PresentationListPageService.instance) {
      PresentationListPageService.instance = new PresentationListPageService(
        props
      );
    }
    return PresentationListPageService.instance;
  }

  private setCriteria(data: any) {
    this.criteria = data;
  }

  public resetCriteria() {
    this.criteria = null;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPageContent(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    //UserLists Props
    compProps = await agent.getPresentationListProps({
      ...args,
      criteria: { ...this.criteria, ...args?.criteria },
    });
    if (compProps) {
      content = { ...content, ...compProps };
    }
    console.log(content);
    return content;
  }

  public async createPresentation(args: CreatePresentationProps) {
    log.info(`invite user`, args);
    const agent = getAgent();
    return agent.createPresentation(args);
  }

  public async getTemplateCostumeTypes() {
    const agent = getAgent();
    return agent.getTemplateCostumeTypes();
  }

  public async importSectionOptType(args: { presentation: string; templateCostumeType: string }) {
    const agent = getAgent();
    return agent.importSectionOptType(args);
  }

  public async updatePresentation(args: UpdatePresentationProps) {
    const agent = getAgent();
    return agent.updatePresentation(args);
  }

  public async deletePresentation(args: DeletePresentationProps) {
    const agent = getAgent();
    return agent.deletePresentation(args);
  }
}
